module.exports = __webpack_public_path__ + "static/media/adm.41272083.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banners/box_courses/adm.jpg
// module id = 25
// module chunks = 0